import { render, staticRenderFns } from "./config-fields.vue?vue&type=template&id=1120002e&scoped=true&"
import script from "./config-fields.vue?vue&type=script&lang=js&"
export * from "./config-fields.vue?vue&type=script&lang=js&"
import style0 from "./config-fields.vue?vue&type=style&index=0&id=1120002e&lang=less&scoped=true&"
import style1 from "./config-fields.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1120002e",
  null
  
)

export default component.exports